import { createSelector } from "reselect";

const selectInstantReq = (state) => state.instantReq;

export const selectInstantReqStep = createSelector(
  selectInstantReq,
  (instantReq) => instantReq.step
);

export const selectInstantReqStatus = createSelector(
  selectInstantReq,
  (instantReq) => instantReq.reqStatus
);

export const selectInstantShowingStatus = createSelector(
  selectInstantReq,
  (instantReq) => instantReq.showingStatus
);

export const selectInstantReqResult = createSelector(
  selectInstantReq,
  (instantReq) => instantReq?.newInstantReqResult
);
